import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Loader2, CheckCircle2, XCircle } from "lucide-react";
import { api } from "@/lib/api";
import { PeepingLogo } from "@/components/PeepingLogo";

// Polls the BACKEND for the verified result — never trusts a redirect/success message.
export default function CheckoutReturn() {
  const [params] = useSearchParams();
  const id = params.get("session");
  const navigate = useNavigate();
  const [s, setS] = useState(null);
  useEffect(() => {
    let tries = 0;
    let timer;
    const poll = () => {
      api.get(`/pay/checkout/${id}`).then((r) => {
        setS(r.data);
        if (["open", "processing"].includes(r.data.status) && tries++ < 15) timer = setTimeout(poll, 1500);
      }).catch(() => setS({ status: "error" }));
    };
    poll();
    return () => clearTimeout(timer);
  }, [id]);
  const ok = s?.status === "completed";
  const pending = !s || ["open", "processing"].includes(s.status);
  const kind = s?.kind || "subscription";
  const title = kind === "tip" ? "Thanks for your tip" : kind === "ppv" ? "Item unlocked" : "Membership active";
  const body = kind === "tip" ? `${s?.plan_name} was sent.` : `${s?.plan_name} is unlocked.`;
  return (
    <div data-testid="checkout-return-screen" className="flex min-h-[80vh] flex-col items-center justify-center px-6 text-center">
      <PeepingLogo className="w-36" />
      <div className="mt-8">
        {pending ? <Loader2 size={40} className="mx-auto animate-spin text-[#d42be8]" /> : ok ? <CheckCircle2 size={44} className="mx-auto text-emerald-400" /> : <XCircle size={44} className="mx-auto text-red-400" />}
        <h1 data-testid="checkout-return-status" className="mt-4 text-xl font-bold">
          {pending ? "Confirming your payment…" : ok ? title : "Payment not completed"}
        </h1>
        <p className="mt-2 text-sm text-[#a7a0af]">
          {pending ? "Waiting for the verified confirmation from PEEPING PAY." : ok ? body : "Your card was declined or the session expired. Nothing was charged."}
        </p>
      </div>
      <button onClick={() => navigate(ok ? "/app/home" : "/app/membership")} data-testid="checkout-return-continue" className="btn-brand mt-8 rounded-full px-8 py-3 text-sm font-semibold">
        {ok ? "Start exploring" : "Back to memberships"}
      </button>
    </div>
  );
}
